<template>
  <common-panel :panel-data="panelData"/>
</template>

<script>
import CommonPanel from "../../common/panel/CommonPanel";
export default {
  name: "BuildingManage",
  components: {CommonPanel},
  data() {
    return {
      panelData: {
        // 左侧树结构设置
        hasTree: true, // 是否包含树结构
        treeProps: { // 树结构参数
          children: 'childNode',
          label: 'name'
        },
        treeMethod: this.$api.systemManage.getBuildTree, // 树查询API
        noneIcon: 'zy-icon-building',
        // 右侧主功能设置
        queryMethod: this.$api.systemManage.getBuildInfo, // 列表数据查询API
        filterForm: [ // 筛选查询数组
          {label: '名称：', prop: 'buildName', type: 'input', value: '', style: 'width: 160px;margin-right: 10px;'}
        ],
        inputValue: '',
        buttons: [ // 工具按钮数组
          {label: '新增', icon: 'zy-icon-plus', type: 'add', handleIndex: -1},
          {label: '修改', icon: 'zy-icon-edit', type: 'edit', handleIndex: -2, text: true},
          {label: '删除', icon: 'zy-icon-delete', type: 'del', handleIndex: 1}
        ],
        methods: { // 主要功能API数组
          add: this.$api.systemManage.addBuildInfo,
          query_prop: 'id',
          query_id: 'id',
          edit: this.$api.systemManage.updateBuildInfo,
          del: this.$api.systemManage.deleteBuildInfo,
          del_prop: 'id',
          excelAPI: '/building'
        },
        tableCheck: true, // 列表是否包含勾选
        tableTitle: '建筑列表',
        tableProps: [ // 列表参数
          {prop: "buildName", label: "建筑名称"},
          {prop: "parentName", label: "上级建筑"},
          {prop: "volLevel", label: "电压等级"},
          {prop: "transNum", label: "变压器个数"},
          {prop: "totalPower", label: "装机容量"},
          {prop: "decPower", label: "申报需量"},
          {prop: "latitude", label: "站点纬度"},
          {prop: "longitude", label: "站点经度"}
        ],
        excelProps: [
          {prop: "BUILD_CODE", label: "建筑编号"},
          {prop: "BUILD_NAME", label: "建筑名称"},
          {prop: "ADDRESS", label: "地址"},
          {prop: "TOTAL_LEVEL", label: "楼层"},
          {prop: "USENESS", label: "功能"},
          {prop: "TOTAL_SQUARE", label: "总面积"},
          {prop: "AC_SQUARE", label: "空调面积"},
          {prop: "HEAT_SQUARE", label: "采暖面积"},
          {prop: "PARENT_ID", label: "上级部门ID"}
        ],
        drawerTitle: '建筑信息', // 弹出抽屉标题
        dialogs: {
          add_edit: {
            title: '建筑信息',
            width: '700px',
            isRefreshTree: true,
            editFlag: false,
            items: [
              {type: 'input', prop: 'buildName', label: '建筑名称：', placeholder: '请输入建筑名称', style: 'width: 315px;', checkIndex: 1},
              {type: 'select', value: '', prop: 'parentId', label: '所属建筑：', placeholder: '请选择所属建筑', checkIndex: -1, style: 'width: 315px;',
                method: this.$api.systemManage.getBuildList,
                props: {value: 'id', label: 'buildName'},
                options: []
              },
              {type: 'input', prop: 'volLevel', label: '电压等级：', placeholder: '请输入电压等级', style: 'width: 315px;', checkIndex: -1},
              {type: 'input', prop: 'transNum', label: '变压器个数：', placeholder: '请输入变压器个数', style: 'width: 315px;', checkIndex: -1},
              {type: 'input', prop: 'totalPower', label: '装机容量：', placeholder: '请输入装机容量', style: 'width: 315px;', checkIndex: -1},
              {type: 'input', prop: 'decPower', label: '申报需量：', placeholder: '请输入申报需量', style: 'width: 315px;', checkIndex: -1},
              {type: 'input', prop: 'latitude', label: '站点纬度：', placeholder: '请输入站点纬度', style: 'width: 315px;', checkIndex: -1},
              {type: 'input', prop: 'longitude', label: '站点经度：', placeholder: '请输入站点经度', style: 'width: 315px;', checkIndex: -1}
            ],
            rules: {
              buildName: [
                {required: true, message: '请输入建筑名称', trigger: 'blur'}
              ],
              parentId: [
                {required: true, message: '请选择所属建筑', trigger: 'blur'}
              ]
            },
            ruleValidator: [
              {name: 'buildName', type: 'name', validator: null, method: this.$api.systemManage.checkBuildName}
            ],
            confirmMethod: null
          }
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/SystemSetting/BuildingManage.vue